{
  "close": "Sluiten"
}
